import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { FiDownload, FiShare2, FiHome } from "react-icons/fi";

import axios from "axios";
import "./DMTReceipt.css"; // 👈 add css below
import { fetchWrapper } from "utils/apiFetch";
import APP_CONFIG from "constants/app";

export default function DMTCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const encData = searchParams.get("encdata");

  const [loading, setLoading] = useState(true);
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!encData) {
      setError("No response data found");
      setLoading(false);
      return;
    }

    decodeResponse(encData);
  }, [encData]);

  const decodeResponse = async (enc) => {
    try {
      const res = await fetchWrapper(`https://api.mokshiq.in/decode_ps?encdata=${enc}`);

      if (res.status) {
        setReceipt(res.data.data);
      } else {
        setError("Unable to decode transaction");
      }
    } catch (err) {
      setError("Server error while decoding");
    } finally {
      setLoading(false);
    }
  };

  const txnStatus = receipt?.transaction_data?.txn_status === "1";
  const bene = receipt?.bene_data;
  const txn = receipt?.transaction_data;

  const downloadReceipt = () => {
    window.print();
  };

  const shareReceipt = async () => {
    if (navigator.share) {
      await navigator.share({
        title: "Mokshiq DMT Receipt",
        text: `₹${txn.amount} transferred to ${bene.name}`,
      });
    } else {
      alert("Sharing not supported");
    }
  };

  if (loading) {
    return <div className="center">Processing transaction...</div>;
  }

  if (error) {
    return (
      <div className="center error">
        <h3>{error}</h3>
        <button onClick={() => navigate("/")}>Back to Home</button>
      </div>
    );
  }

  return (
    <div className="receipt-wrapper">
      <div className="receipt-card">
        <img
          src={APP_CONFIG.ORGANISATION_LOGO}
          alt="Mokshiq"
          className="logo"
        />

        <h2 className={txnStatus ? "success" : "failed"}>
          {txnStatus ? "Money Transfer Successful" : "Money Transfer Failed"}
        </h2>

        <h1>₹ {txn.amount}</h1>

        <div className="section">
  <h4>Beneficiary Details</h4>

  <div className="grid">
    <div className="item">
      <label>Name</label>
      <span>{bene.name}</span>
    </div>

    <div className="item">
      <label>Bank</label>
      <span>{bene.bankname}</span>
    </div>

    <div className="item">
      <label>Account</label>
      <span>{bene.accno}</span>
    </div>

    <div className="item">
      <label>IFSC</label>
      <span>{bene.ifsc}</span>
    </div>
  </div>
</div>

<div className="section">
  <h4>Transaction Details</h4>

  <div className="grid">
    <div className="item">
      <label>UTR</label>
      <span>{txn.utr}</span>
    </div>

    <div className="item">
      <label>Reference ID</label>
      <span>{txn.refid}</span>
    </div>

    <div className="item">
      <label>Date</label>
      <span>{txn.transaction_date}</span>
    </div>

    <div className="item">
      <label>Status</label>
      <span className={txnStatus ? "success" : "failed"}>
        {txnStatus ? "SUCCESS" : "FAILED"}
      </span>
    </div>
  </div>
</div>


        <div className="section">
          <div className="row"><span>UTR</span><span>{txn.utr}</span></div>
          <div className="row"><span>Ref ID</span><span>{txn.refid}</span></div>
          <div className="row"><span>Date</span><span>{txn.transaction_date}</span></div>
        </div>

        <div className="actions">
  <button className="icon-btn" onClick={downloadReceipt}>
    <FiDownload /> Download
  </button>

  <button className="icon-btn secondary" onClick={shareReceipt}>
    <FiShare2 /> Share
  </button>

  <button className="icon-btn outline" onClick={() => navigate("/wallet_dmt")}>
    <FiHome /> Home
  </button>
</div>

      </div>
    </div>
  );
}
